import { useEffect, useRef } from 'react';

export function useDebounce(fn: (...args) => void, delay: number) {
  const timeoutId = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (!!timeoutId.current) clearTimeout(timeoutId.current!);
    };
  }, []);

  return (...args) => {
    if (timeoutId.current) clearTimeout(timeoutId.current!);

    timeoutId.current = setTimeout(() => fn(...args), delay);
  };
}